// extracted by mini-css-extract-plugin
module.exports = {"card":"BaseCard-card-3Wkohvf-n_ borders-default-2bP5aoPLs1 borders-round-3HcGll3T5X color-whiteBg-1jN-U4yQ5M","footer":"BaseCard-footer-2Fs4VsYWIW"};